<div class="cmn_block">
  <router-outlet></router-outlet>
</div>

<ngx-ui-loader pbColor="#FFCD1D" fgsColor="#FFCD1D" fgsType="three-bounce" threshold="0" hasProgressBar="false">
</ngx-ui-loader>

<p-toast showTransitionOptions="1ms" hideTransitionOptions="3ms" position="top-center"></p-toast>

<!-- App Update Notification -->
<div *ngIf="updateAvailable" class="app-notification-popup">
  <i class="fa fa-bell padding-left-10" style="font-size: 24px; font-size: 18px; color: #61baff;" aria-hidden="true"></i>
  <span class="padding-left-10">New version of the app is available!</span>
  <div class="vertical-center">
    <button class="btn later-btn" (click)="updateAvailable = false">LATER</button>
    <button class="btn btn-primary" (click)="onReload()">Update Now</button>
  </div>
  <!-- <div class="padding-left-10">
    <span style="font-size: 12px;">Click here for update info</span>
    <b><i class="fa padding-left-10" [ngClass]="{'fa-angle-up': showUpdateDetails, 'fa-angle-down' : !showUpdateDetails}" 
      aria-hidden="true" (click)="showUpdateDetails = !showUpdateDetails;" style=" font-size: 17px; vertical-align: middle;"></i></b>
      <div *ngIf="showUpdateDetails">
        <ul>
          <li>Can notify user if new version of the app available</li>
          <li>Added icons for journey monitoring</li>
          <li>Added icons for Shuttle Management</li>
        </ul>
      </div>
  </div> -->
</div>